import type { ReactNode } from "react";
import type { StyleProp, TextStyle } from "react-native";
import { SupportingSubtitleText } from "./SupportingSubtitleText";

type Props = {
  children: ReactNode;
  numberOfLines?: number;
  style?: StyleProp<TextStyle>;
};

/**
 * Shared secondary line for glass cards and rows.
 * Used under row/card titles where the text should read quieter than the title.
 */
export function CardSubtitleText({ children, numberOfLines, style }: Props) {
  return (
    <SupportingSubtitleText numberOfLines={numberOfLines} style={style}>
      {children}
    </SupportingSubtitleText>
  );
}

export default CardSubtitleText;
